import React, { memo } from 'react';

const EmailTemplatesEmpty = memo((props) => (
    <svg
        width={308}
        height={164}
        viewBox="0 0 308 164"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <rect width={308} height={164} fill="white" />
        <rect x={167} y={104.5} width={35} height={35} rx={2} fill="#F2F5F6" />
        <rect x={16} y={19.5} width={167} height={125} rx={2} fill="#B3D9C8" />
        <rect x={28} y={28.5} width={143} height={6} rx={1} fill="white" />
        <rect x={28} y={42.5} width={143} height={34} rx={2} fill="white" />
        <rect x={16} y={85.5} width={167} height={44} fill="#D6EDFF" />
        <rect x={28} y={90.5} width={67} height={34} rx={2} fill="#3380B9" />
        <rect
            x={104.5}
            y={91}
            width={66}
            height={33}
            rx={1.5}
            stroke="#3380B9"
            strokeDasharray="2 2"
        />
        <rect x={161.25} y={100.75} width={34.5} height={34.5} rx={1.75} fill="white" />
        <rect
            x={161.25}
            y={100.75}
            width={34.5}
            height={34.5}
            rx={1.75}
            stroke="#E6E6E6"
            strokeWidth={0.5}
        />
        <path
            d="M184.042 112.458V123.542H172.958V112.458H184.042ZM184.042 110.875H172.958C172.087 110.875 171.375 111.587 171.375 112.458V123.542C171.375 124.413 172.087 125.125 172.958 125.125H184.042C184.913 125.125 185.625 124.413 185.625 123.542V112.458C185.625 111.587 184.913 110.875 184.042 110.875ZM180.194 117.889L177.819 120.953L176.125 118.903L173.75 121.958H183.25L180.194 117.889Z"
            fill="#0060A7"
        />
        <rect x={219} y={29} width={73} height={111} rx={2} fill="#F2F5F6" />
        <rect x={214.5} y={24.5} width={34} height={34} rx={3.5} fill="white" />
        <rect x={214.5} y={24.5} width={34} height={34} rx={3.5} stroke="#E6E6E6" />
        <path
            d="M230.312 47.8333V37.5417H225.958V35.1667H237.042V37.5417H232.687V47.8333H230.312Z"
            fill="#007E45"
        />
        <rect x={253.5} y={24.5} width={34} height={34} rx={3.5} fill="white" />
        <rect x={253.5} y={24.5} width={34} height={34} rx={3.5} stroke="#E6E6E6" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M275.25 44.73C274.648 44.73 274.11 44.9675 273.698 45.3396L268.054 42.0542C268.093 41.8721 268.125 41.69 268.125 41.5C268.125 41.31 268.093 41.1279 268.054 40.9458L273.635 37.6921C274.062 38.0879 274.625 38.3333 275.25 38.3333C276.564 38.3333 277.625 37.2725 277.625 35.9583C277.625 34.6442 276.564 33.5833 275.25 33.5833C273.936 33.5833 272.875 34.6442 272.875 35.9583C272.875 36.1483 272.907 36.3304 272.946 36.5125L267.365 39.7663C266.938 39.3704 266.375 39.125 265.75 39.125C264.436 39.125 263.375 40.1858 263.375 41.5C263.375 42.8142 264.436 43.875 265.75 43.875C266.375 43.875 266.938 43.6296 267.365 43.2338L273.002 46.5271C272.962 46.6933 272.938 46.8675 272.938 47.0417C272.938 48.3163 273.975 49.3533 275.25 49.3533C276.525 49.3533 277.562 48.3163 277.562 47.0417C277.562 45.7671 276.525 44.73 275.25 44.73Z"
            fill="#007E45"
        />
        <rect x={214.5} y={63.5} width={34} height={34} rx={3.5} fill="white" />
        <rect x={214.5} y={63.5} width={34} height={34} rx={3.5} stroke="#E6E6E6" />
        <path
            d="M228.333 85.25L231.5 82.8354L234.667 85.25L233.479 81.3313L236.646 79.075H232.767L231.5 74.9583L230.233 79.075H226.354L229.521 81.3313L228.333 85.25ZM231.5 88.4167C230.405 88.4167 229.376 88.2089 228.412 87.7932C227.449 87.3776 226.611 86.8136 225.899 86.1011C225.186 85.3886 224.622 84.5507 224.207 83.5875C223.791 82.6243 223.583 81.5951 223.583 80.5C223.583 79.4049 223.791 78.3757 224.207 77.4125C224.622 76.4493 225.186 75.6115 225.899 74.899C226.611 74.1865 227.449 73.6224 228.412 73.2068C229.376 72.7912 230.405 72.5833 231.5 72.5833C232.595 72.5833 233.624 72.7912 234.587 73.2068C235.551 73.6224 236.388 74.1865 237.101 74.899C237.813 75.6115 238.378 76.4493 238.793 77.4125C239.209 78.3757 239.417 79.4049 239.417 80.5C239.417 81.5951 239.209 82.6243 238.793 83.5875C238.378 84.5507 237.813 85.3886 237.101 86.1011C236.388 86.8136 235.551 87.3776 234.587 87.7932C233.624 88.2089 232.595 88.4167 231.5 88.4167ZM231.5 86.8333C233.268 86.8333 234.766 86.2198 235.993 84.9927C237.22 83.7656 237.833 82.2681 237.833 80.5C237.833 78.732 237.22 77.2344 235.993 76.0073C234.766 74.7802 233.268 74.1667 231.5 74.1667C229.732 74.1667 228.234 74.7802 227.007 76.0073C225.78 77.2344 225.167 78.732 225.167 80.5C225.167 82.2681 225.78 83.7656 227.007 84.9927C228.234 86.2198 229.732 86.8333 231.5 86.8333Z"
            fill="#007E45"
        />
        <rect x={253.5} y={63.5} width={34} height={34} rx={3.5} fill="white" />
        <rect x={253.5} y={63.5} width={34} height={34} rx={3.5} stroke="#E6E6E6" />
        <path
            d="M264.167 86.0417V84.4583H272.083V86.0417H264.167ZM264.167 82.875V81.2917H276.833V82.875H264.167ZM264.167 79.7083V78.125H276.833V79.7083H264.167ZM264.167 76.5417V74.9583H276.833V76.5417H264.167Z"
            fill="#007E45"
        />
        <rect x={253.5} y={102.5} width={34} height={34} rx={3.5} fill="white" />
        <rect x={253.5} y={102.5} width={34} height={34} rx={3.5} stroke="#E6E6E6" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M268.442 123.142L264.8 119.5L268.442 115.858L267.333 114.75L262.583 119.5L267.333 124.25L268.442 123.142ZM272.558 123.142L276.2 119.5L272.558 115.858L273.667 114.75L278.417 119.5L273.667 124.25L272.558 123.142Z"
            fill="#007E45"
        />
        <mask
            id="email-templates-mask"
            style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x={262}
            y={114}
            width={17}
            height={11}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M268.442 123.142L264.8 119.5L268.442 115.858L267.333 114.75L262.583 119.5L267.333 124.25L268.442 123.142ZM272.558 123.142L276.2 119.5L272.558 115.858L273.667 114.75L278.417 119.5L273.667 124.25L272.558 123.142Z"
                fill="white"
            />
        </mask>
        <g mask="url(#email-templates-mask)" />
    </svg>
));

EmailTemplatesEmpty.displayName = 'EmailTemplatesEmpty';

export default EmailTemplatesEmpty;
